import { fromJS } from 'immutable'
import * as ReducerActions from './actions'

const initialState = fromJS({
    data: {
        contenidos: undefined,
        tiposContenido: undefined,
        tipoContenidoSelected: undefined,
        contenido: undefined,
    }
})

export default function contenidoReducer(state = initialState, action) {
    
    if(action.type === ReducerActions.SET_TIPOS_CONTENIDO){
        return state.setIn(["data", "tiposContenido"], action.payload)
    }

    if(action.type === ReducerActions.SET_TIPO_CONTENIDO_SELECTED){
        return state.setIn(["data", "tipoContenidoSelected"], action.payload)
    }

    if(action.type === ReducerActions.SET_CONTENIDOS){
        return state.setIn(["data", "contenidos"], action.payload)
    }

    if(action.type === ReducerActions.SET_CONTENIDO_INACTIVO){
        let myState = state.toJS();
        
        let contenidos = myState.data.contenidos

        contenidos = contenidos.filter((c) => { return c.idContenido !== action.payload })

        return state.setIn(["data", "contenidos"], contenidos)
    }

        
    if(action.type === ReducerActions.SET_CONTENIDOSBYID){
        return state.setIn(["data", "contenido"], action.payload)
    }

    return state
}